import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * The PriiPeople native plugin (ios/App/App/PriiPeoplePlugin.swift): QR scanner, full brightness for your code, the
 * address book, Prii's page in Settings. On the web each call is a quiet no-op or reports `unavailable`.
 */
const PriiPeople = registerPlugin('PriiPeople');
const native = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';

export const canScan = () => native();
export const canReadContacts = () => native();

/** { value } | { cancelled: true } | { myCode: true } | { denied: true } | { unavailable: true } */
export async function scanCode() {
  if (!native()) return { unavailable: true };
  try {
    return await PriiPeople.scan();
  } catch (err) {
    if (err?.code === 'denied') return { denied: true };
    throw err;
  }
}

export async function brightenScreen() {
  if (native()) await PriiPeople.brighten().catch(() => {});
}

export async function restoreScreenBrightness() {
  if (native()) await PriiPeople.restoreBrightness().catch(() => {});
}

/** { contacts: [{ name, emails, phones }] } | { denied: true } | { unavailable: true } */
export async function readContacts() {
  if (!native()) return { unavailable: true };
  try {
    return await PriiPeople.contacts();
  } catch (err) {
    if (err?.code === 'denied') return { denied: true };
    throw err;
  }
}

export async function openAppSettings() {
  if (native()) await PriiPeople.openSettings().catch(() => {});
}
